/* React */
import React, { useEffect, useState } from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

/* Thunks */
import { fetchFeatureTypes } from "src/redux/thunks/custom-cohorts/featureTypesThunk";

/* Utils */
import CustomCohortsWrapper from "src/utils/wrapper/custom-cohorts-wrapper/CustomCohortsWrapper";

/* Components */
import CohortBuilder from "src/components/insights/custom-cohorts/cohort-builder/CohortBuilder";
import CohortListContainer from "src/components/insights/custom-cohorts/cohort-list/CohortListContainer";

const CustomCohorts: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const modalState = useSelector(
    (state: RootState) => state.modal
  );
  const { showModal } = modalState;

  const insightsFilterState = useSelector(
    (state: RootState) => state.insightsFilter
  );

  const { mainCondition } = insightsFilterState;

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );

  const { currentDiseaseId, customCohortsByDisease } =
    customCohortsState;

  const cohorts = currentDiseaseId
    ? customCohortsByDisease[currentDiseaseId]?.cohorts ??
      []
    : [];

  const [showCohortList, setShowCohortList] =
    useState<boolean>(false);

  useEffect(() => {
    if (!mainCondition.value) return;
    dispatch(fetchFeatureTypes(mainCondition.value));
  }, [dispatch, mainCondition.value]);

  // If there are no cohorts, list should be not shown
  useEffect(() => {
    if (cohorts.length === 0) {
      setShowCohortList(false);
    } else {
      setShowCohortList(true);
    }
  }, [showModal, cohorts.length]);

  /**
   * Custom cohorts should only be visible, when showModal is true.
   * Otherwise, component is shown for a short period of time after
   * refreshing the page.
   */
  return showModal ? (
    <CustomCohortsWrapper showCohortList={showCohortList}>
      <CohortBuilder />
      <CohortListContainer
        showCohortList={showCohortList}
        setShowCohortList={setShowCohortList}
      />
    </CustomCohortsWrapper>
  ) : undefined;
};

export default CustomCohorts;
